import { Checkbox, Typography } from '@material-tailwind/react'
import { FormControlLabel } from '@mui/material'
import { useController } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const GasConnection = ({ control, register, setValue, setErrorsValidService }: any) => {

    const { t } = useTranslation()


    const {
        field: { ref, value, onChange, ...inputProps },
        formState: { errors }
    } = useController({
        name: 'service_2',
        control,
        defaultValue: false
    });


    return (
        <div className='flex flex-col gap-[24px]'>
            <FormControlLabel
                control={
                    <Checkbox
                        {...inputProps}
                        inputRef={ref}
                        onChange={(e) => {
                            onChange(e.target.checked)
                            if (e.target.checked) setErrorsValidService(false)
                        }}
                    />
                }
                label={t('new_connection.service_2')}
            />
            {
                value &&
                <div className='flex flex-col gap-[24px]'>
                    <div className='flex flex-col gap-[16px]'>
                        <Typography variant='lead' className='text-gray-800 text-[16px] font-normal' >
                            {t('new_connection.gas_consumption_title')}
                        </Typography>
                        <div className='flex flex-col gap-[8px]'>
                            <Checkbox
                                {...register(`gas_consumption_1`)}
                                labelProps={{
                                    className: 'text-[14px] des:text-[16px]'
                                }}
                                className='rounded-full checked:bg-white border-2'
                                icon={<span className='block w-[10px] h-[10px] bg-black rounded-full ' />}
                                label={t('new_connection.gas_consumption_title_1')}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setValue('gas_consumption_2', false)
                                        setValue('gas_consumption_3', false)
                                        setValue('gas_consumption_4', false)
                                    }
                                }}
                            />
                            <Checkbox
                                {...register(`gas_consumption_2`)}
                                labelProps={{
                                    className: 'text-[14px] des:text-[16px]'
                                }}
                                className='rounded-full checked:bg-white border-2'
                                icon={<span className='block w-[10px] h-[10px] bg-black rounded-full ' />}
                                label={t('new_connection.gas_consumption_title_2')}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setValue('gas_consumption_1', false)
                                        setValue('gas_consumption_3', false)
                                        setValue('gas_consumption_4', false)
                                    }
                                }}
                            />
                            <Checkbox
                                {...register(`gas_consumption_3`)}
                                labelProps={{
                                    className: 'text-[14px] des:text-[16px]'
                                }}
                                className='rounded-full checked:bg-white border-2'
                                icon={<span className='block w-[10px] h-[10px] bg-black rounded-full ' />}
                                label={t('new_connection.gas_consumption_title_3')}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setValue('gas_consumption_1', false)
                                        setValue('gas_consumption_2', false)
                                        setValue('gas_consumption_4', false)
                                    }
                                }}
                            />
                            <Checkbox
                                {...register(`gas_consumption_4`)}
                                labelProps={{
                                    className: 'text-[14px] des:text-[16px]'
                                }}
                                className='rounded-full checked:bg-white border-2'
                                icon={<span className='block w-[10px] h-[10px] bg-black rounded-full ' />}
                                label={t('new_connection.gas_consumption_title_4')}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setValue('gas_consumption_1', false)
                                        setValue('gas_consumption_2', false)
                                        setValue('gas_consumption_3', false)
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            }

        </div>
    )
}

export default GasConnection